import Header from '../Header/Header'
import React from 'react'
import Footer from '../Footer/Footer'
import { useNavigate } from 'react-router-dom'

function Features () {
  const navigate = useNavigate()
  const backgroundImageUrl = '/assets/images/banners/14.jpg'

  return (
    <>
      <Header />
      <main className='tw-bg-slate-50 lg:tw-pt-20'>
        <section
          className='tw-relative tw-flex tw-items-center tw-justify-start tw-min-h-[500px] md:tw-min-h-[600px] tw-bg-cover tw-bg-center'
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${backgroundImageUrl})`
          }}
        >
          <div className='tw-container tw-mx-auto tw-w-full tw-px-4 tw-text-white'>
            <h2 className='tw-text-2xl md:tw-text-3xl xl:tw-text-4xl tw-font-bold tw-mb-6 tw-text-white'>
              Poznaj, jak Kreatlo zmienia pracę projektanta!
            </h2>
            <p className='tw-text-sm md:tw-text-base xl:tw-text-lg tw-mb-8 tw-text-white'>
              Zorganizuj każdy etap projektu – od planowania po realizację.
              <br />
              Z nami zyskasz klarowny przepływ informacji, większą produktywność i realne oszczędności czasu.
            </p>
            <a
              href='/register'
              onClick={(e) => {
                e.preventDefault()
                navigate('/register')
              }}
              className='tw-inline-block tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 hover:tw-text-white focus:tw-bg-green'
            >
              Wypróbuj teraz
            </a>
          </div>
        </section>

        <InfoSection
          heading='Panel Projektu – wszystko w jednym miejscu'
          description='W Kreatlo z łatwością zorganizujesz swoją przestrzeń projektową, dodając wizualizacje, rysunki techniczne i inne pliki do przejrzystych folderów. Każdy materiał możesz opatrzyć komentarzem, opisem lub udostępnić klientowi oraz członkom zespołu. Taka forma prezentacji ułatwia komunikację, przyspiesza proces podejmowania decyzji i pozwala klientowi lepiej zrozumieć koncepcję projektu – bez zbędnych maili i nieporozumień.'
          imageUrl='/assets/images/features/1.png'
          videoUrl='https://youtube.com/link-do-filmu-1'
        />

        <InfoSection
          heading='Automatyczne listy wyposażenia i kosztorysy – bez Excela, bez frustracji'
          description='Zamiast tracić czas na ręczne tworzenie dokumentów, buduj szczegółowe listy produktów bezpośrednio podczas przeglądania ofert sklepów online. Twoje propozycje są przejrzyste, uporządkowane i gotowe do przedstawienia klientowi – bez potrzeby korzystania z Worda czy Excela. W kilka sekund sprawdzisz, co zostało zaakceptowane, zamówione lub nadal wymaga decyzji. Zyskaj pełną kontrolę nad budżetem i wyposażeniem – szybko, intuicyjnie, bez błędów.'
          imageUrl='/assets/images/features/2,3,7.png'
          videoUrl='https://youtube.com/link-do-filmu-2'
          reverse
        />

        <InfoSection
          heading='Oszczędzaj czas z wtyczką Kreatlo – Twoim inteligentnym asystentem zakupowym'
          description='Tworzenie list wyposażenia jeszcze nigdy nie było tak szybkie. Dzięki wtyczce Kreatlo zapiszesz nazwę, cenę, zdjęcie, link i dostawcę produktu prosto z dowolnej strony – w zaledwie kilka sekund i bez przeklejania danych. Wystarczy kilka kliknięć, a produkt trafia bezpośrednio do Twojego projektu. Nie możesz pobrać zdjęcia? Żaden problem – wytnij je z ekranu i dodaj od razu do zestawienia. Zautomatyzuj swoją pracę, eliminuj błędy i odzyskaj czas na to, co naprawdę ważne: projektowanie.'
          imageUrl='/assets/images/features/2,3,7.png'
          videoUrl='https://youtube.com/link-do-filmu-3'
        />

        <InfoSection
          heading='Katalog Produktów i modele 3D – wszystko, czego potrzebujesz, w jednym miejscu'
          description='Zyskaj błyskawiczny dostęp do szerokiej bazy produktów z przekierowaniem do strony producenta i modeli 3D, bez tracenia czasu na przeszukiwanie setek stron internetowych. Dzięki naszemu Katalogowi Produkty znajdziesz to, czego szukasz, w mgnieniu oka – szybko i wygodnie. Pobieraj modele 3D bezpośrednio z bieżąco aktualizowanej bazy, a jeśli potrzebujesz dodatkowych informacji, łatwo skontaktujesz się z producentami, otrzymując natychmiastową pomoc i wycenę. Skróć czas realizacji projektu i miej pełną kontrolę nad każdym etapem.'
          imageUrl='/assets/images/features/4.png'
          videoUrl='https://youtube.com/link-do-filmu-4'
          reverse
        />

        <InfoSection
          heading='Szybka i przejrzysta komunikacja z klientem'
          description='Zaproś klienta do swojej przestrzeni projektowej i udostępnij mu propozycje w nowoczesnej, interaktywnej formie – dostępnej online, 24/7, bez potrzeby logowania. Pozwól mu komentować, akceptować i zadawać pytania w czasie rzeczywistym, bez konieczności organizowania spotkań czy prowadzenia długich rozmów. Ty decydujesz, jakie informacje widzi: cena, ilość, dostawca, link do produktu – wszystko pod Twoją kontrolą. Zyskaj czas, uprość proces decyzyjny i buduj profesjonalne relacje dzięki wygodnej i transparentnej komunikacji.'
          imageUrl='/assets/images/features/5.png'
          videoUrl='https://youtube.com/link-do-filmu-5'
        />

        <InfoSection
          heading='Tablice zadań oraz Harmonogram — pełna kontrola nad każdym etapem projektu'
          description='Nasze tablice zadań umożliwiają monitorowanie postępów w czasie rzeczywistym oraz przypisywanie konkretnych obowiązków członkom zespołu. Każdy krok — od planowania po finalizację — jest zawsze przejrzyście widoczny i pod pełną kontrolą. Możesz definiować zależności między zadaniami, co zapobiega rozpoczęciu kolejnego etapu zanim poprzedni nie zostanie ukończony, dzięki czemu cały proces przebiega płynnie i bez opóźnień.'
          imageUrl='/assets/images/features/6.png'
          videoUrl='https://youtube.com/link-do-filmu-6'
          reverse
        />

        <InfoSection
          heading='Panel Projektu – wszystko w jednym miejscu'
          description={`W Kreatlo z łatwością zorganizujesz swoją przestrzeń projektową, dodając wizualizacje, rysunki techniczne i inne pliki do przejrzystych folderów. Każdy materiał możesz opatrzyć komentarzem, opisem lub udostępnić klientowi oraz członkom zespołu. Taka forma prezentacji ułatwia komunikację, przyspiesza proces podejmowania decyzji i pozwala klientowi lepiej zrozumieć koncepcję projektu – bez zbędnych maili i nieporozumień.
                    
                    Udostępniaj harmonogramy, kosztorysy i szczegółowe dane, aby wszyscy partnerzy byli na bieżąco z postępem prac. Dzięki temu utrzymujesz pełną transparentność i sprawną komunikację, minimalizując ryzyko błędów i nieporozumień.
                    `}
          imageUrl='/assets/images/features/2,3,7.png'
          videoUrl='https://youtube.com/link-do-filmu-7'
        />

        <section className='tw-bg-white tw-py-12 md:tw-py-16'>
          <div className='tw-container tw-mx-auto tw-px-6 tw-text-center'>
            <h4 className='tw-text-lg md:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-slate-800 tw-mb-3'>
              Chcesz wiedzieć więcej?
            </h4>
            <p className='tw-text-xs md:tw-text-sm xl:tw-text-base tw-text-slate-600 tw-max-w-xl tw-mx-auto'>
              Potrzebujesz więcej informacji na temat konkretnej funkcji?
              <br />
              Skontaktuj się z pomocą techniczną, wyślij do nas maila
            </p>
            <a
              href='mailto:help@kreatlo.com'
              className='
                                    tw-mt-4 tw-inline-block tw-text-lg tw-font-semibold
                                    tw-text-teal hover:tw-text-teal/40 hover:tw-underline
                                    tw-transition-colors
                                '
            >
              help@kreatlo.com
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default Features

interface InfoSectionProps {
  heading: string
  description: string
  imageUrl: string
  reverse?: boolean
  videoUrl?: string
}

function InfoSection ({ heading, description, imageUrl, reverse = false, videoUrl }: InfoSectionProps) {
  return (
    <section className='tw-py-16 md:tw-py-24 tw-bg-white'>
      <div className='tw-container tw-mx-auto tw-px-4'>
        <div
          className={`
                        tw-flex tw-flex-col tw-items-center tw-gap-12 md:tw-gap-16
                        ${reverse ? 'md:tw-flex-row-reverse' : 'md:tw-flex-row'}
                    `}
        >
          <div className='tw-w-full md:tw-w-1/2'>
            <h3 className='tw-text-2xl md:tw-text-3xl xl:tw-text-4xl tw-font-bold tw-text-slate-800 tw-mb-4'>
              {heading}
            </h3>
            <p className='tw-text-slate-600 tw-text-sm md:tw-text-base xl:tw-text-lg tw-leading-relaxed tw-whitespace-pre-line'>
              {description}
            </p>
          </div>

          <div className='tw-w-full md:tw-w-1/2 tw-relative'>
            <img
              src={imageUrl}
              alt={heading}
              className='tw-rounded-lg tw-shadow-xl tw-w-full tw-h-auto'
            />
            {videoUrl && (
              <a
                href={videoUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='tw-absolute tw-bottom-5 tw-right-5 tw-z-10 tw-inline-flex tw-items-center tw-gap-3 tw-bg-green hover:tw-bg-opacity-90 tw-text-white hover:tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded-xl tw-transition-colors tw-shadow-lg'
              >
                <span className='tw-flex tw-items-center tw-justify-center tw-bg-white tw-w-7 tw-h-7 md:tw-w-8 md:tw-h-8 tw-rounded-full'>
                  <svg
                    className='tw-text-green'
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='currentColor'
                    xmlns='http://www.w3.org/2000/svg'
                    style={{ marginLeft: '3px' }}
                  >
                    <path d='M8 5V19L19 12L8 5Z' />
                  </svg>
                </span>
                <span className='tw-text-sm md:tw-text-base'>Obejrzyj film!</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
